import React from "react";

import type { CustomCellRendererProps } from "ag-grid-react";
import { Box, Text } from "@mantine/core";

export default (props: CustomCellRendererProps) => {
  return props.value ? (
    <Box px={5}>
      <Text size="16px">{props.value}</Text>
    </Box>
  ) : (
    <React.Fragment></React.Fragment>
  );
};
